import styled from 'styled-components';
import { PadBox } from './primitives';

export const Panel = styled(PadBox)`
  border: 2px solid ${({ theme }) => theme.colors.grey[2]};
  border-radius: ${({ theme }) => theme.borderRadius[1]};
  background-color: ${({ theme }) => theme.colors.grey[1]};
`;
